module.exports = __webpack_public_path__ + "static/media/megatv.c959e62d.svg";